import { useQuery } from '@tanstack/react-query'
import { supabase, supabaseReady } from '@/lib/supabase'
import type { ProgramWeek, ProgramOverview } from '@/types'

export interface MyProgram {
  found: boolean
  access?: 'active' | 'paused'
  billingRequired?: boolean
  subscriptionStatus?: string | null
  hasProgram?: boolean
  programId?: string
  name?: string
  overview?: ProgramOverview | null
  currentWeek?: number
  unlockedWeek?: number
  totalWeeks?: number
  nextUnlockAt?: string
  weeks?: ProgramWeek[]
}

/**
 * The signed-in athlete's own program — fetched via the server function that
 * only returns UNLOCKED weeks (future weeks never reach the device) and blocks
 * access when paused.
 */
export function useMyProgram(enabled: boolean) {
  return useQuery({
    queryKey: ['my-program'],
    enabled: enabled && supabaseReady,
    queryFn: async (): Promise<MyProgram> => {
      const { data, error } = await supabase.rpc('get_my_program')
      if (error) throw error
      return (data ?? { found: false }) as MyProgram
    },
  })
}
